import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaRepasseTradeResponseExtend } from "../interface/entuba/repasse-trade/IEntubaRepasseTradeResponse";
import { IEntubaRepasseTradeRequest } from "../interface/entuba/repasse-trade/IEntubaRepasseTradeRequest";

enum EntubaRepasseTradeServiceEnum {
  base = "/",
  upload = "/upload",
  getAll = "/get-all",
  get = "/get/"

}

export default class EntubaRepasseTradeService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/entuba/repasse");
  }
  public getAll = async (): Promise<IEntubaRepasseTradeResponseExtend[]> => await this.GET(EntubaRepasseTradeServiceEnum.getAll);
  public getById = async id => await this.GET(EntubaRepasseTradeServiceEnum.get + id);
  public upload = async (data: IEntubaRepasseTradeRequest) => await this.POST(EntubaRepasseTradeServiceEnum.upload, data);

}


// WEBPACK FOOTER //
// ./src/services/api/EntubaRepasseTrade.service.ts